import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { UnmountClosed as Collapse } from 'react-collapse';
import dateFormat from '../../../utils/dateFormat';

function DocketHeader({ open, data }) {
  if (isEmpty(data.html)) {
    return null;
  }

  return (
    <Collapse isOpened={open}>
      <div id="docket-header" className="no-filter-search inside-block docket-header" key="docket-header">
        <div id="docket-header-content">
          <div className="header-timestamp">
            Docket Header Last Updated: {dateFormat(data.modified, 'M/D/YYYY h:mm a')}
          </div>
          <div dangerouslySetInnerHTML={{ __html: data.html }} />
        </div>
      </div>
    </Collapse>
  );
}

DocketHeader.defaultProps = {
  data: {},
  // used to identify this specific component when used as React.Child
  // https://github.com/facebook/react/issues/4915
  displayName: 'DocketHeader',
};

DocketHeader.propTypes = {
  open: PropTypes.bool.isRequired,
  data: PropTypes.object,
  // eslint-disable-next-line
  displayName: PropTypes.string,
};

export default DocketHeader;



// WEBPACK FOOTER //
// ./src/components/case/docket/DocketHeader.jsx